import { Link } from 'react-router-dom';

const page: React.CSSProperties = {
  maxWidth: 720,
  margin: '0 auto',
  padding: '48px 24px 80px',
  fontFamily: 'system-ui, -apple-system, sans-serif',
  color: '#1f2937',
  lineHeight: 1.7,
};

const h1Style: React.CSSProperties = {
  fontSize: 28,
  fontWeight: 800,
  color: '#111827',
  margin: '0 0 8px',
};

const metaStyle: React.CSSProperties = {
  fontSize: 13,
  color: '#6b7280',
  margin: '0 0 40px',
};

const h2Style: React.CSSProperties = {
  fontSize: 18,
  fontWeight: 700,
  color: '#111827',
  margin: '36px 0 10px',
};

const pStyle: React.CSSProperties = {
  margin: '0 0 14px',
  fontSize: 15,
};

const todoStyle: React.CSSProperties = {
  background: '#fef9c3',
  border: '1px solid #fde047',
  borderRadius: 6,
  padding: '6px 10px',
  fontSize: 13,
  color: '#854d0e',
  display: 'inline-block',
};

const footnoteStyle: React.CSSProperties = {
  marginTop: 40,
  padding: '16px',
  background: '#f9fafb',
  borderRadius: 8,
  fontSize: 13,
  color: '#6b7280',
  lineHeight: 1.6,
};

export function TermsOfService() {
  return (
    <div style={page}>
      <Link to="/" style={{ display: 'inline-block', fontSize: 13, color: '#6b7280', textDecoration: 'none', marginBottom: 32 }}>
        ← Back to Housewizrd
      </Link>

      <h1 style={h1Style}>Terms of Service — Early Access</h1>
      <p style={metaStyle}>Last updated: July 1, 2026 · Housewizrd LLC, Nahunta, Georgia</p>

      <p style={pStyle}>
        By using Housewizrd you agree to the following:
      </p>

      <h2 style={h2Style}>1. Who We Are</h2>
      <p style={pStyle}>
        Housewizrd is a home maintenance tracking app and contractor marketplace. We connect
        homeowners with contractors — we are not a contractor, home inspector, or licensed
        professional ourselves.
      </p>

      <h2 style={h2Style}>2. What Housewizrd Is Not</h2>
      <p style={pStyle}>
        Task content, health scores, and maintenance suggestions are informational only — not
        professional inspection, engineering, or safety advice. Always use your own judgment
        and consult a licensed professional when in doubt.
      </p>

      <h2 style={h2Style}>3. The Contractor Marketplace</h2>
      <p style={pStyle}>
        Housewizrd connects homeowners and contractors but is not a party to any service agreement
        between them. We verify contractor license and insurance status through automated checks
        — this is not a guarantee of work quality, safety, or contractor conduct. You hire
        contractors at your own discretion.
      </p>

      <h2 style={h2Style}>4. Your Account</h2>
      <p style={pStyle}>
        You are responsible for keeping your account credentials secure. You must provide accurate
        information when creating an account.
      </p>

      <h2 style={h2Style}>5. Payments</h2>
      <p style={pStyle}>
        Contractor subscription billing is handled through Stripe. Refund policies are described
        in your billing settings.
      </p>

      <h2 style={h2Style}>6. Intellectual Property</h2>
      <p style={pStyle}>
        Housewizrd and its content are owned by Housewizrd LLC. You retain ownership of any content
        you upload (photos, documents). You grant us a license to store and display it to operate
        the service.
      </p>

      <h2 style={h2Style}>7. Limitation of Liability</h2>
      <p style={pStyle}>
        Housewizrd is provided as-is during early access. To the extent permitted by law, Housewizrd
        is not liable for indirect, incidental, or consequential damages arising from use of the
        app or contractor services found through it.
      </p>

      <h2 style={h2Style}>8. Changes to These Terms</h2>
      <p style={pStyle}>
        We will notify active users of material changes to these terms. Continued use after
        notice constitutes acceptance.
      </p>

      <h2 style={h2Style}>9. Governing Law</h2>
      <p style={pStyle}>
        These terms are governed by the laws of the State of Georgia.
      </p>

      <h2 style={h2Style}>10. Contact</h2>
      <p style={todoStyle}>TODO: Insert contact email address before App Store submission</p>

      <p style={footnoteStyle}>
        These terms will be reviewed and expanded by a licensed attorney as Housewizrd grows out
        of early access.
      </p>
    </div>
  );
}
